<div class="timer-wrapper" [style.bottom.px]="isAssumingProfile ? 90 : 10">
    <div class="timer__message">
        Time left to finish this form
    </div>
    <div class="timer__time" [class.expiring]="isExpiringSoon()">
        {{ remainingMinutes }}:{{ remainingSeconds }}
    </div>
</div>

<sl-dialog [open]="modalOpen" [noHeader]="true" (sl-hide)="onClose()">
    <span>Session Expired</span>
    <sl-divider></sl-divider>
    <span>Your current form has expired due to exceeding the time limit. Click "Refresh" to complete and submit your form.</span>
    <sl-divider></sl-divider>
    <div class="button-wrapper">
        <sl-button (click)="onRefresh()">Refresh</sl-button>
    </div>
</sl-dialog>
